var React = require("react");
var CardActionItem = require("./generic/CardActionItem.jsx"); 
const {  Link  } = require('react-router-dom');
let AssetDetailsLink = require("./AssetDetailsLink.jsx");

class ViewButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        const { objUrl } = this.props;

        return <AssetDetailsLink
                    objUrl={objUrl}
                    Content={
                        ()=> <CardActionItem 
                            {...this.props}
                            text="View"
                            icon="icon-file.svg"
                            tooltip="View Asset"
                            hideTooltip
                        />
                    }/>
    }
}

module.exports = ViewButton;
